import { useEffect, useRef } from "react";
import { http } from "@/lib/api";
import { metaCtx } from "@/lib/pixel";
import { redeemStashedRef } from "@/lib/referral";
import { useTranslation } from "react-i18next";
import { isolate } from "@/i18n/format";

export const AuthCallback = () => {
  const done = useRef(false);
  const { t } = useTranslation();

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(window.location.hash.replace(/^#/, "")).get("session_id");
    (async () => {
      try {
        await http.post("/auth/session", { meta: metaCtx() }, { headers: { "X-Session-ID": sid } });
        const r = await redeemStashedRef();
        if (r) sessionStorage.setItem("vale_ref_success",
          t("auth.refSuccess", { n: r.bonus_days, name: isolate(r.referrer_name) }));
        window.history.replaceState({}, "", "/dashboard");
        window.location.href = "/dashboard";
      } catch {
        window.location.href = "/login";
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="auth-callback">
      <p className="text-sm text-[var(--ink-soft)]">{t("auth.signingIn")}</p>
    </div>
  );
};
